<base-support-modal [title]="title" [btnOkClass]="'btn-primary'" [btnOkLabel]="'Применить'" (onOk)="ok()" >
	<p>
		<datetimepicker [(dt)]="uberStartDate" [format]="'DD.MM.YYYY'"></datetimepicker>
	</p>
</base-support-modal>
